const config = {
    API_URL: 'https://freelancer.payflow.ch/api/',
};

export default config;